import { render } from "./UploadAvatar.vue?vue&type=template&id=7f5e3620"
import script from "./UploadAvatar.vue?vue&type=script&lang=js"
export * from "./UploadAvatar.vue?vue&type=script&lang=js"

import "./UploadAvatar.vue?vue&type=style&index=0&id=7f5e3620&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__